<template>
    <v-form
        ref="form"
        v-model="form.valid"
        lazy-validation
    >
        <v-card>
            <v-card-title>
                <v-subheader>Dados do Benefício</v-subheader>
                <v-spacer></v-spacer>
                <v-btn
                    large
                    color="primary"
                    :disabled="!form.valid"
                    @click.native="save(formMethod)"
                    v-show="!form.loading"
                >Salvar</v-btn>
            </v-card-title>

            <v-divider></v-divider>

            <v-progress-linear :indeterminate="true" v-show="form.loading"></v-progress-linear>

            <v-card-text v-show="!form.loading">
                <v-container>
                    <v-row>
                        <v-col cols="12" md="2" class="text-center">
                            <input-avatar :setup.sync="form.inputAvatar"></input-avatar>
                        </v-col>

                        <v-col cols="12" md="10">
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-autocomplete
                                        v-model="benefit.client"
                                        :items="clients"
                                        :rules="form.rules.client"
                                        prepend-icon="contacts"
                                        label="Pesquisar empresa"
                                        item-text="name"
                                        item-value="objectId"
                                        no-data-text="Nenhum resultado"
                                        filled
                                        required
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field
                                        v-model="benefit.contact"
                                        :type="'Contato (Obrigatório)'"
                                        :rules="form.rules.contact"
                                        label="Email de contato"
                                        filled
                                        required
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12">
                                    <v-text-field
                                        v-model="benefit.name"
                                        :type="'Nome do Benefício (Obrigatório)'"
                                        :rules="form.rules.name"
                                        label="Nome do Benefício"
                                        filled
                                        required
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12">
                                    <v-textarea
                                        v-model="benefit.intro"
                                        label="Intro"
                                        no-resize
                                        filled
                                        required
                                    ></v-textarea>
                                    <v-textarea
                                        v-model="benefit.profile"
                                        label="Perfil"
                                        :rules="form.rules.profile"
                                        no-resize
                                        filled
                                        required
                                    ></v-textarea>
                                    <v-textarea
                                        v-model="benefit.about"
                                        label="Beneficio"
                                        :rules="form.rules.about"
                                        no-resize
                                        filled
                                        required
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-title>
                <v-spacer></v-spacer>
                <v-btn
                    large
                    color="primary"
                    :disabled="!form.valid"
                    @click.native="save(formMethod)"
                    v-show="!form.loading"
                >Salvar</v-btn>
            </v-card-title>
        </v-card>
    </v-form>
</template>

<script>
import API from '@/api'
import InputAvatar from '@/components/InputAvatar'

export default {
    name: 'form-benefit',
    components: {
        InputAvatar
    },
    data: function () {
        return {
            clients: [],
            form: {
                valid: false,
                rules: {
                    client: [ v => !!v || 'Empresa é obrigatório' ],
                    name: [
                        v => !!v || 'Nome do Benefício é obrigatório',
                        v => (v && v.length >= 3) || 'O nome do benefício deve ter ao menos de 3 caracteres'
                    ],
                    about: [
                        v => !!v || 'Benefício é obrigatório',
                        v => (v && v.length >= 3) || 'O benefício deve ter ao menos de 3 caracteres'
                    ],
                    contact: [
                        v => !!v || 'E-mail de contato é obrigatório',
                        v => /.+@.+/.test(v) || 'E-mail de contato deve ser válido'
                    ]
                },
                loading: true,
                inputAvatar: {
                    previous: undefined,
                    img: undefined,
                    name: undefined,
                    placeholder: 'logo',
                    file: undefined
                }
            },
            benefit: {
                objectId: undefined,
                name: undefined,
                intro: undefined,
                profile: undefined,
                about: undefined,
                contact: undefined,
                logo: undefined,
                client: {
                    objectId: undefined
                }
            }
        }
    },
    watch: {
        'benefit.logo': {
            handler: function (val, oldVal) {
                if (oldVal !== val && val !== undefined) {
                    this.form.inputAvatar.img = (val.url === undefined) ? undefined : val.url
                    this.form.inputAvatar.previous = (val.url === undefined) ? undefined : val.url
                } else {
                    this.form.inputAvatar.name = this.benefit.name
                }
            },
            deep: true
        },
        'benefit.client': {
            handler: function (val, oldVal) {
                if (oldVal !== val) {
                    if (this.$route.params.id != null) {
                        this.clients = [val]
                    }
                }
            },
            deep: true
        }
    },
    mounted () {
        if (this.$route.params.id != null) {
            this.loadData()
        } else {
            this.fetchClients()
        }
    },
    computed: {
        formMethod () {
            return (this.$route.params.id != null)
        }
    },
    methods: {
        async fetchClients () {
            this.clients = await this.$helpers.getAllClient()
            this.form.loading = false
        },
        loadData () {
            let endpoint = API.EndPoints.getClub
            endpoint.id = this.$route.params.id
            new API(endpoint).request().then(response => {
                this.benefit = Object.assign({}, response.body)
                this.form.loading = false
            }, (e) => {
                this.$helpers.requestError(e)
            })
        },
        formatObject () {
            let logo = { '__op': 'Delete' }
            if (this.benefit.logo) {
                logo = this.benefit.logo
                logo.__type = 'File'
            }
            let clientId = (this.$route.params.id != null) ? this.benefit.client.objectId : this.benefit.client
            let params = JSON.stringify({
                'logo': logo,
                'client': { '__type': 'Pointer', 'objectId': clientId, 'className': 'Client' },
                'about': this.benefit.about,
                'intro': this.benefit.intro,
                'profile': this.benefit.profile,
                'contact': this.benefit.contact,
                'name': this.benefit.name
            })
            return params
        },
        async save (boolean) {
            if (this.$refs.form.validate()) {
                this.form.valid = false
                try {
                    await this.deleteFile()
                    await this.uploadFile()
                } catch (error) {
                    alert(error)
                }
                if (boolean) {
                    this.update()
                } else {
                    this.create()
                }
            }
        },
        saveSuccess () {
            this.$router.push('/clube').catch(e => {})
        },
        saveError () {
            alert('Ocorreu um erro ao salvar, avise a Mocka!')
        },
        deleteFile () {
            return new Promise((resolve, reject) => {
                if (
                    (this.form.inputAvatar.file === undefined && this.form.inputAvatar.img === undefined) ||
                    (this.form.inputAvatar.file !== undefined && this.form.inputAvatar.img !== undefined)
                ) {
                    if (this.form.inputAvatar.previous !== undefined) {
                        let endpoint = API.EndPoints.deleteFile
                        let params = {
                            useMasterKey: true,
                            url: this.form.inputAvatar.previous
                        }
                        new API(endpoint, params).request().then(() => {
                            this.benefit.logo = undefined
                            resolve()
                        }, () => { resolve() })
                    } else {
                        resolve()
                    }
                } else {
                    resolve()
                }
            })
        },
        uploadFile () {
            return new Promise((resolve, reject) => {
                if (this.form.inputAvatar.file) {
                    let endpoint = API.EndPoints.upload
                    endpoint.filename = this.$helpers.normalizeFilename(this.form.inputAvatar.file.name)
                    new API(endpoint, this.form.inputAvatar.file).request()
                        .then(response => {
                            this.benefit.logo = response.data
                            this.benefit.logo.url = response.data.url
                            resolve()
                        }, error => {
                            alert(error.response.data.error)
                            reject(error.response.data.error)
                        })
                } else {
                    resolve()
                }
            })
        },
        create () {
            let endpoint = API.EndPoints.addClub
            endpoint.id = this.$route.params.id
            new API(endpoint, this.formatObject()).request()
                .then(() => {
                    this.saveSuccess()
                }, () => {
                    this.saveError()
                })
        },
        update () {
            let endpoint = API.EndPoints.editClub
            endpoint.id = this.$route.params.id
            new API(endpoint, this.formatObject()).request()
                .then(() => {
                    this.saveSuccess()
                }, () => {
                    this.saveError()
                })
        }
    }
}
</script>
